import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [inviteToken, setInviteToken] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const invite = params.get('invite');
    if (invite) setInviteToken(invite);
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API}/auth/register`, {
        email,
        password,
        full_name: fullName,
        invite_token: inviteToken || null
      });

      login(response.data.token, response.data.user);
      toast.success('Registration successful!');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Registration failed');
    }
  };

  return (
    <div className="grid lg:grid-cols-2 h-screen w-full">
      <div className="bg-slate-900 text-white p-10 flex flex-col justify-between relative overflow-hidden hidden lg:flex">
        <div className="relative z-10">
          <div className="text-3xl font-black tracking-tighter">TrackBuild.ca</div>
          <p className="mt-4 text-slate-300 text-lg">Join your team and manage projects efficiently</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-slate-50">
        <div className="w-full max-w-md space-y-8">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-slate-900">Create your account</h2>
            <p className="mt-2 text-sm text-slate-600">Get started with TrackBuild.ca</p>
          </div>
          <form onSubmit={handleRegister} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2" data-testid="fullname-label">Full Name</label>
              <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900"
                placeholder="John Doe"
                required
                data-testid="fullname-input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2" data-testid="email-label">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900"
                placeholder="you@example.com"
                required
                data-testid="email-input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2" data-testid="password-label">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900"
                placeholder="********"
                required
                data-testid="password-input"
              />
              <p className="text-xs text-slate-500 mt-1">
                Min 8 chars, uppercase, lowercase, number, special char (!@#$%^&*)
              </p>
            </div>
            {inviteToken && (
              <div className="text-sm text-green-600" data-testid="invite-message">You're registering with an invite token</div>
            )}
            <button
              type="submit"
              className="w-full bg-slate-900 text-white py-2 px-4 rounded-md hover:bg-slate-800 transition-colors"
              data-testid="register-button"
            >
              Register
            </button>
          </form>
          <div className="text-center">
            <a href="/login" className="text-sm text-blue-600 hover:underline" data-testid="login-link">Already have an account? Sign in</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
